import { useTheme } from '@mui/material';

export const IntroIcon1 = ({ className }: { className: string }) => {
    const theme = useTheme();
    const primaryIconStrokeColor = theme.colors.other.icon.stroke.primary;

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="48"
            height="49"
            viewBox="0 0 48 49"
            className={className}
        >
            <path
                fill={primaryIconStrokeColor}
                d="M17.749 22.625a9.75 9.75 0 0 1 9.751 9.751c0 .897-.727 1.624-1.624 1.624h-2.769l.02-1.75h2.623c-.071-4.359-3.626-7.875-8.001-7.875h-4.998A8 8 0 0 0 4.75 32.25h14.322l-.01 1.75H4.624A1.624 1.624 0 0 1 3 32.376a9.75 9.75 0 0 1 9.751-9.751h4.998Zm18.758-7.618a.879.879 0 0 1 1.236 0 .879.879 0 0 1 0 1.236l-7 7a.879.879 0 0 1-1.236 0l-3.5-3.5a.879.879 0 0 1 0-1.236.879.879 0 0 1 1.236 0l2.882 2.882 6.382-6.382ZM15.25 6a7 7 0 1 1 .001 14.001A7 7 0 0 1 15.25 6Zm0 1.75a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5Z"
            />
        </svg>
    );
};
